import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { SampleAcknoledgeModalComponent } from '../../shared/components/sample-acknoledge-modal/sample-acknoledge-modal.component'

@Component({
  selector: 'app-sample-acknolege',
  templateUrl: './sample-acknolege.component.html',
  styleUrls: ['./sample-acknolege.component.scss']
})
export class SampleAcknolegeComponent implements OnInit {

  isLoading = true;
  Errors = null;
  data: any = [];
  samples: any = [];
  encounters: any = [];
  Success;
  billId;
  message;
  startdate = "";
  enddate = "";

  stateForm = new FormGroup({
    id: new FormControl('', Validators.required),
    bill_id: new FormControl('', Validators.required),
    is_collect_action: new FormControl('', Validators.required),
    is_acknowledge_action: new FormControl('', Validators.required),
  });



  constructor(public router: Router, private sample: SampleService, private modal: ModalService, private _snackBar: MatSnackBar, public setting: SettingsService, public auth: AuthServiceService, public bill:BillingService) { }

  ngOnInit(): void {
    this.getResult()

    this.bill
  .getEncounters()
  .subscribe(
    (resSuccess) => {
      this.encounters = resSuccess
      this.isLoading = false
      console.log(resSuccess)
    },
    (resErr) => {
      this.isLoading = false;
      this.Errors = resErr;
    }
  )
  }

  getResult() {
    this.sample
    .getResults(this.startdate, this.enddate)
    .subscribe(
      (resSuccess:any) => {
        this.data = resSuccess.data
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    )
  }

  getSamples(billId) {
    this.billId = billId;
    const data = { bill_id: this.billId };
    this.modal.openModal(SampleAcknoledgeModalComponent, 'modal', data);
  }

  


}
